import { z } from 'zod'

import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import {
  indexSymbolsQueryOptions,
  openTradesQueryOptions,
  signalSessionsQueryOptions,
} from '@/features/signals/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import {
  pagingParams,
  sessionDateParamSchema,
  symbolSearchParamSchema,
} from '@/screens/signals/search'

/**
 * Client paging over the one unpaged answer (99 rows on dev), and the client's
 * own `q` (a symbol prefix, as Trend's and History's boxes take it: the read
 * has no search). `date` is the picker's: the read is current only, so a past one only turns
 * the page to its no-data state (`asks/signals-dates.md`).
 */
export const openTradesSearchSchema = z.object({
  date: sessionDateParamSchema,
  ...pagingParams(),
  q: symbolSearchParamSchema,
})

/**
 * The `/market/signals/open-trades` loader. MAIN: every open trade, keyed on
 * nothing. SECONDARY: the index symbols (which rows link).
 */
export async function loadOpenTrades({
  context: { queryClient },
  preload,
}: {
  context: RouterContext
  preload: boolean
}): Promise<void> {
  if (!preload) {
    prefetchRouteData(queryClient, signalSessionsQueryOptions())
    prefetchRouteData(queryClient, indexSymbolsQueryOptions())
  }
  await ensureRouteData(queryClient, openTradesQueryOptions())
}
